<template>
  <div class="page-wrapper has-tabbar">
     <div class="index-container index-homepage">
        <div class="m-flex index-nav1 original-brand-nav">
          <div class="btn m-padding-1 brand-button" style="animation-delay: 0s;">BULGARI</div>
          <div class="btn m-padding-1 brand-button" style="animation-delay: 0.2s;">GUCCI</div>
          <div class="btn m-padding-1 brand-button" style="animation-delay: 0.4s;">CHANEL</div>
          <div class="btn m-padding-1 brand-button" style="animation-delay: 0.6s;">DIOR</div>
          <div class="btn m-padding-1 brand-button" style="animation-delay: 0.8s;">YSL</div>
      </div>

      <div class="m-margin-1">
        <video id="mvideo" class="index-video" loop autoplay muted playsinline src="@/assets/static/IMG_3379.mp4"></video>
      </div>


      <div class="vip-list m-flex p1">
          <div class="vip-card m-flex" v-for="vip in vipList" :key="vip.level">
              <div class="vip-icon-wrapper">
                  <div class="vip-rank-badge">{{ vip.level }}</div><img class="w2 vip-icon" :src="vip.pic">
                  <div class="vip-glow"></div>
                  <div class="vip-scan-line"></div>
              </div>
              <div class="vip-info">
                  <div class="vip-name">{{ vip.name }}</div>
                  <div class="vip-detail">{{ t('home.orderCount') }} {{ vip.order_num }}</div>
                  <!-- <div class="vip-detail">{{ t('home.upgradeAmount') }} {{ vip.num }}</div> -->
              </div>
          </div>
      </div>

      <div class="m-margin-1">
          <div class="m-flex m-row-center text-center index-nav1">
              <div class="nav-item" @click="goToRecharge">
                  <div class="nav-icon-wrapper">
                    <img class="w2 nav-icon" src="@/assets/static/index_img/tab_1.png">
                      <div class="nav-ripple"></div>
                  </div>
                  <div class="nav-text">{{ t('home.recharge') }}</div>
              </div>
              <div class="nav-item" @click="goToWithdraw">
                  <div class="nav-icon-wrapper">
                    <img class="w2 nav-icon" src="@/assets/static/index_img/tab_2.png">
                      <div class="nav-ripple"></div>
                  </div>
                  <div class="nav-text">{{ t('home.withdraw') }}</div>
              </div>
              <div class="nav-item" @click="goToTeam">
                  <div class="nav-icon-wrapper">
                    <img class="w2 nav-icon" src="@/assets/static/index_img/tab_4.png">
                      <div class="nav-ripple"></div>
                  </div>
                  <div class="nav-text">{{ t('home.team') }}</div>
              </div>
          </div>



          <div class="m-margin-1">
              <div class="index-title caps h3 tech-title" style="margin:15px 0;" >
                  <div class="title-line-left"></div>
                  <img class="w1 title-icon" src="@/assets/static/index_img/title_icon.png" >
                  <span class="title-text" >{{ t('home.commission') }}</span>
                  <div class="title-line-right"></div>
              </div>
              <div class="new-list">
                  <div class="commission-scroll-container">
                      <div class="commission-scroll-list" :style="{ transform: `translateY(${scrollOffset}px)` }">
                          <div class="commission-item" v-for="(item, index) in commissionList" :key="index">
                              <div class="commission-content">
                                <img class="user-avatar" src="@/assets/static/touxiang.png" alt="avatar">
                                <span class="user-tel">{{ item.userTel }}</span>
                                <span class="commission-amount">{{ t('home.commission') }} {{ appConfig.currency.symbol }}{{ item.amount }}</span>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>


          </div>

          <div class="img-row">
            <img src="@/assets/static/index_img/1.png" >
          </div>

          <div class="img-row m-margin-1">
            <img src="@/assets/static/index_img/3.jpg">
          </div>

          <div class="p6 container"> {{ t('home.newProducts') }} </div>

          <div class="p1 m-margin-1-y"> {{ t('home.newProductsDesc') }} </div>

          <div class="btn inline m-padding-1 p1 cta-button"> {{ t('home.buyNow') }} </div>

          <div class="mdole goods-wrap">
              <div class="goods-container">
                  <div class="goods-item" v-for="(item, index) in goodsList" :key="index">
                      <div class="img-row"><img :src="item.image"></div>
                      <div class="goods-name u-line-2">{{ item.name }}</div>
                      <div class="goods-price">{{ appConfig.currency.symbol }}{{ item.price.toFixed(2) }}</div>
                  </div>
              </div>
          </div>
      </div>

      <div class="img-row m-margin-1 text-center p1 container2">
          <img src="@/assets/static/index_img/bottom.png">
          <div> {{ t('home.nowAvailable') }} </div>
          <div class="info"> {{ t('home.nowAvailableDesc') }} </div>
      </div>

      <!-- <div class="index-foot text-center p1">
          <div class="h1" data-imt_insert_failed="1">{{ t('home.footerTitle') }}</div>
          <div> {{ t('home.footerFollow') }} </div>
          <div class="shop">{{ t('home.footerShop') }}</div>
      </div> -->
     </div>
     <el-backtop :bottom="100" />
  </div>
</template>


<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import { getHomeData } from '@/api'
import { appConfig } from '../../config/app.js'
import '@/assets/css/index.css'
import bvlgariNecklace from '@/assets/static/goods/bvlgari-necklace.jpg'
import gucciBag from '@/assets/static/goods/gucci-bag.jpg'
import chanelBag from '@/assets/static/goods/chanel-bag.jpg'
import diorTote from '@/assets/static/goods/dior-tote.jpg'
import yslHeels from '@/assets/static/goods/ysl-heels.png'
import cartierWatch from '@/assets/static/goods/cartier-watch.png'

const { t } = useI18n()
const router = useRouter()

const loading = ref(false)

// 获取首页数据
const fetchHomeData = async () => {
  try {
    loading.value = true
    const response = await getHomeData()
  
    vipList.value = response.data.data.level
   

    
  } catch (error) {
    // console.error('获取首页数据失败:', error)
    // ElMessage.error(t('common.loadDataError'))
  } finally {
    loading.value = false
  }
}

const goToRecharge = () => {
  router.push('/recharge')
}

const goToWithdraw = () => {
  router.push('/withdraw')
}

const goToTeam = () => {
  router.push('/team')
}

const vipList = ref([])

const commissionList = ref([
  { userTel: 'ENS**', amount: 1274 },
  { userTel: 'CO**', amount: 113 },
  { userTel: 'LOC**', amount: 173 },
  { userTel: 'HO * *', amount: 381 },
  { userTel: 'qia*jc', amount: 807 },
  { userTel: 'place*jm', amount: 660 },
  { userTel: 'Erh**tk', amount: 503 },
  { userTel: 'jaca*mc', amount: 383 },
  { userTel: 'denge*vf', amount: 330 }
])

const goodsList = ref([
  {
    image: bvlgariNecklace,
    name: 'BVLGARI/Bulgari B.ZERO1 series Design Legend 18K gold rose gold spiral paved diamond necklace 355060',
    price: 127506.00
  },
  {
    image: gucciBag,
    name: 'GUCCI Interlocking Double G Men\'s Mini Handbag Messenger Bag Crossbody Bag [Camera Bag]',
    price: 22742.00
  },
  {
    image: chanelBag,
    name: 'CHANEL/Chanel Classic WOC Women\'s Black Pebbled Calfskin Flip Shoulder Crossbody Bag Chain Bag',
    price: 62763.00
  },
  {
    image: diorTote,
    name: 'DIOR/Dior 24 new Dior Book Tote women\'s dark blue logo jacquard cowhide small crossbody/handbag M1325CZBB_M928',
    price: 65136.00
  },
  {
    image: yslHeels,
    name: 'Ysl/Yves Saint Laurent 24SS01 women\'s logo slingback high heels 630107',
    price: 19232.00
  },
  {
    image: cartierWatch,
    name: 'Cartier Official Flagship Store Ballon Bleu Blue Balloon Quartz Mechanical Watch Stainless Steel Watch',
    price: 96163.00
  }
])

const scrollOffset = ref(0)
let scrollInterval = null

onMounted(() => {
  // 获取首页数据
  fetchHomeData()
  
  scrollInterval = setInterval(() => {
    scrollOffset.value -= 60
    if (scrollOffset.value <= -60 * commissionList.value.length) {
      scrollOffset.value = 0
    }
  }, 2000)
})

onUnmounted(() => {
  if (scrollInterval) {
    clearInterval(scrollInterval)
  }
})
</script>


<style scoped>
.vip-list {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.vip-list::-webkit-scrollbar {
  display: none;
}

body{
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale
}

.m-flex-1{
    flex: 1
}

.m-flex-wrap{
    flex-wrap: wrap
}

.m-flex-shrink{
    flex-shrink: 0
}

.m-col-top{
    align-items: flex-start
}

.m-margin-1{
    margin: 10px
}

.m-margin-1-y{
    margin: 10px 0
}

.m-padding-1{
    padding: 15px
}

.m-padding-2{
    padding: 30px
}

.u-line-2{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical
}

.btn[data-v-8ee1fb6e]:hover {
    opacity: .8
}

.btn[data-v-8ee1fb6e]:active {
    transform: scale(.98)
}

.btn.inline{
    display: inline-block
}

.p1{
    padding: 15px
}

.h1{
    font-size: 24px;
    font-weight: 700
}

.container{
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px
}

@media screen and (max-width: 768px) {
    .m-padding-1{
        padding:7.5px
    }

    .m-margin-1{
        margin: 5px
    }
}

[data-v-8ee1fb6e]::-webkit-scrollbar {
    width: 6px;
    height: 6px
}

[data-v-8ee1fb6e]::-webkit-scrollbar-thumb {
    background: #0003;
    border-radius: 3px
}

[data-v-8ee1fb6e]::-webkit-scrollbar-track {
    background: #0000000d
}

@keyframes fadeIn-8ee1fb6e {
    0% {
        opacity: 0
    }

    to {
        opacity: 1
    }
}

@keyframes slideUp-8ee1fb6e {
    0% {
        transform: translateY(20px);
        opacity: 0
    }

    to {
        transform: translateY(0);
        opacity: 1
    }
}

@keyframes pulse-8ee1fb6e {
    0% {
        transform: scale(1)
    }

    50% {
        transform: scale(1.05)
    }

    to {
        transform: scale(1)
    }
}

.gradient-bg{
    background: linear-gradient(135deg,#667eea,#764ba2)
}

.card{
    background: #fff;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 4px 12px #0000001a;
    transition: all .3s ease
}

.card[data-v-8ee1fb6e]:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px #00000026
}

.overlay{
    position: fixed;
    inset: 0;
    background: #00000080;
    z-index: 1000
}

.modal{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: #fff;
    border-radius: 8px;
    padding: 30px;
    z-index: 1001;
    max-width: 90%;
    max-height: 90vh;
    overflow-y: auto
}

.badge{
    display: inline-block;
    padding: 2px 8px;
    font-size: 12px;
    line-height: 1;
    color: #fff;
    background-color: #667eea;
    border-radius: 10px
}

.list{
    list-style: none;
    padding: 0;
    margin: 0
}

.list .list-item{
    padding: 15px;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color .3s ease
}

.list .list-item[data-v-8ee1fb6e]:last-child {
    border-bottom: none
}

.list .list-item[data-v-8ee1fb6e]:hover {
    background-color: #f9f9f9
}

.input{
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 14px;
    transition: border-color .3s ease
}

.input[data-v-8ee1fb6e]:focus {
    outline: none;
    border-color: #667eea
}

.button{
    padding: 10px 20px;
    background: #667eea;
    color: #fff;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all .3s ease
}

.button[data-v-8ee1fb6e]:hover {
    background: #3958e4
}

.button[data-v-8ee1fb6e]:active {
    transform: scale(.98)
}

.button[data-v-8ee1fb6e]:disabled {
    opacity: .5;
    cursor: not-allowed
}

.loading{
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 2px solid #f3f3f3;
    border-top: 2px solid #667eea;
    border-radius: 50%;
    animation: spin-8ee1fb6e 1s linear infinite
}

@keyframes spin-8ee1fb6e {
    0% {
        transform: rotate(0)
    }

    to {
        transform: rotate(360deg)
    }
}

.clearfix[data-v-8ee1fb6e]:after {
    content: "";
    display: table;
    clear: both
}

.ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.no-select{
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.img-responsive{
    max-width: 100%;
    height: auto;
    display: block
}

.divider{
    height: 1px;
    background: #e0e0e0;
    margin: 15px 0
}

.empty-state{
    padding: 40px 20px;
    text-align: center;
    color: #999
}

.empty-state .empty-icon{
    font-size: 48px;
    margin-bottom: 20px;
    opacity: .3
}

.empty-state .empty-text{
    font-size: 14px
}

.hidden{
    display: none!important
}

.visible{
    display: block!important
}

.float-left{
    float: left
}

.float-right{
    float: right
}

.text-left{
    text-align: left
}

.text-right{
    text-align: right
}

.font-bold{
    font-weight: 700
}

.font-normal{
    font-weight: 400
}

.text-primary{
    color: #333
}

.text-regular{
    color: #666
}

.text-secondary{
    color: #999
}

.text-theme{
    color: #667eea
}

.bg-theme{
    background-color: #667eea
}

@media screen and (max-width: 768px) {
    .hide-mobile{
        display:none!important
    }
}

@media screen and (min-width: 768px) {
    .show-mobile{
        display:none!important
    }
}

@media screen and (min-width: 1200px) {
    .hide-desktop{
        display:none!important
    }
}

@media screen and (max-width: 1199px) {
    .show-desktop{
        display:none!important
    }
}

.video-background-container{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 0;
    overflow: hidden
}

.video-background-container .video-background{
    position: absolute;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    transform: translate(-50%,-50%);
    filter: blur(20px) saturate(1.2) contrast(1.1);
    object-fit: cover;
    will-change: transform;
    backface-visibility: hidden
}

.video-background-container .video-overlay{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 20% 50%,rgba(120,119,198,.3) 0%,transparent 50%),radial-gradient(circle at 80% 80%,rgba(255,119,198,.2) 0%,transparent 50%),radial-gradient(circle at 40% 20%,rgba(255,219,98,.2) 0%,transparent 50%),linear-gradient(180deg,#ffffff80,#ffffff4d);
    backdrop-filter: blur(2px)
}

.video-background-container .tech-grid-bg{
    position: absolute;
    inset: 0;
    background-image: linear-gradient(rgba(120,119,198,.03) 2px,transparent 2px),linear-gradient(90deg,rgba(120,119,198,.03) 2px,transparent 2px);
    background-size: 100px 100px;
    animation: gridSlide-8ee1fb6e 30s linear infinite
}

.video-background-container .particles-container{
    position: absolute;
    inset: 0
}

.video-background-container .particles-container .particle{
    position: absolute;
    background: radial-gradient(circle,rgba(255,255,255,.8) 0%,transparent 70%);
    border-radius: 50%;
    pointer-events: none
}

.video-background-container .particles-container .particle[data-v-8ee1fb6e]:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    height: 100%;
    background: #7877c680;
    border-radius: 50%;
    filter: blur(3px)
}

.video-background-container .particles-container .particle.particle-1{
    width: 5px;
    height: 5px;
    left: 22%;
    top: 110%;
    animation: floatParticle-8ee1fb6e 30s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 4s
}

.video-background-container .particles-container .particle.particle-2{
    width: 5px;
    height: 5px;
    left: 8%;
    top: 114%;
    animation: floatParticle-8ee1fb6e 35s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 1s
}

.video-background-container .particles-container .particle.particle-3{
    width: 4px;
    height: 4px;
    left: 73%;
    top: 101%;
    animation: floatParticle-8ee1fb6e 29s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 14s
}

.video-background-container .particles-container .particle.particle-4{
    width: 4px;
    height: 4px;
    left: 31%;
    top: 116%;
    animation: floatParticle-8ee1fb6e 36s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 12s
}

.video-background-container .particles-container .particle.particle-5{
    width: 5px;
    height: 5px;
    left: 93%;
    top: 108%;
    animation: floatParticle-8ee1fb6e 35s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 19s
}

.video-background-container .particles-container .particle.particle-6{
    width: 5px;
    height: 5px;
    left: 99%;
    top: 113%;
    animation: floatParticle-8ee1fb6e 28s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 2s
}

.video-background-container .particles-container .particle.particle-7{
    width: 5px;
    height: 5px;
    left: 95%;
    top: 116%;
    animation: floatParticle-8ee1fb6e 30s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 9s
}

.video-background-container .particles-container .particle.particle-8{
    width: 6px;
    height: 6px;
    left: 72%;
    top: 111%;
    animation: floatParticle-8ee1fb6e 21s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 5s
}

.video-background-container .particles-container .particle.particle-9{
    width: 5px;
    height: 5px;
    left: 39%;
    top: 108%;
    animation: floatParticle-8ee1fb6e 31s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 18s
}

.video-background-container .particles-container .particle.particle-10{
    width: 3px;
    height: 3px;
    left: 97%;
    top: 101%;
    animation: floatParticle-8ee1fb6e 32s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 18s
}

.video-background-container .particles-container .particle.particle-11{
    width: 4px;
    height: 4px;
    left: 32%;
    top: 110%;
    animation: floatParticle-8ee1fb6e 39s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 18s
}

.video-background-container .particles-container .particle.particle-12{
    width: 6px;
    height: 6px;
    left: 91%;
    top: 101%;
    animation: floatParticle-8ee1fb6e 22s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 13s
}

.video-background-container .particles-container .particle.particle-13{
    width: 5px;
    height: 5px;
    left: 28%;
    top: 107%;
    animation: floatParticle-8ee1fb6e 37s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 11s
}

.video-background-container .particles-container .particle.particle-14{
    width: 5px;
    height: 5px;
    left: 95%;
    top: 117%;
    animation: floatParticle-8ee1fb6e 31s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 5s
}

.video-background-container .particles-container .particle.particle-15{
    width: 5px;
    height: 5px;
    left: 40%;
    top: 120%;
    animation: floatParticle-8ee1fb6e 29s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 15s
}

.video-background-container .particles-container .particle.particle-16{
    width: 3px;
    height: 3px;
    left: 73%;
    top: 105%;
    animation: floatParticle-8ee1fb6e 40s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 20s
}

.video-background-container .particles-container .particle.particle-17{
    width: 4px;
    height: 4px;
    left: 93%;
    top: 114%;
    animation: floatParticle-8ee1fb6e 38s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 20s
}

.video-background-container .particles-container .particle.particle-18{
    width: 3px;
    height: 3px;
    left: 41%;
    top: 112%;
    animation: floatParticle-8ee1fb6e 29s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 4s
}

.video-background-container .particles-container .particle.particle-19{
    width: 5px;
    height: 5px;
    left: 42%;
    top: 102%;
    animation: floatParticle-8ee1fb6e 24s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 12s
}

.video-background-container .particles-container .particle.particle-20{
    width: 3px;
    height: 3px;
    left: 42%;
    top: 115%;
    animation: floatParticle-8ee1fb6e 25s linear infinite,particleGlow-8ee1fb6e 3s ease-in-out infinite;
    animation-delay: 2s
}

@keyframes gridSlide-8ee1fb6e {
    0% {
        transform: translate(0)
    }

    to {
        transform: translate(100px,100px)
    }
}

@keyframes floatParticle-8ee1fb6e {
    0% {
        transform: translateY(0) translate(0);
        opacity: 0
    }

    5% {
        opacity: .8
    }

    95% {
        opacity: .8
    }

    to {
        transform: translateY(-120vh) translate(17px);
        opacity: 0
    }
}

@keyframes particleGlow-8ee1fb6e {
    0%,to {
        filter: brightness(1) blur(3px)
    }

    50% {
        filter: brightness(1.5) blur(4px)
    }
}

.index-container{
    position: relative;
    background: var(--bg-primary);
    min-height: 100vh
}

@media screen and (max-width: 1199px) {
    .index-container{
        background:var(--bg-primary)
    }

    .index-container .video-background-container{
        display: none
    }
}

@media screen and (min-width: 1200px) {
    .index-container{
        background:var(--card-bg-glass, rgba(255, 255, 255, .85));
        box-shadow: 0 0 50px #0000001a
    }
}

.index-nav1{
    overflow-x: auto;
    overflow-y: hidden;
    margin: 0;
    padding: 15px 10px;
    position: relative;
    background: var(--bg-secondary);
    backdrop-filter: blur(40px) saturate(180%);
    box-shadow: 0 1px 0 var(--border-color) inset,0 -1px #0000001a;
    border-bottom: 1px solid var(--border-color);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    gap: 0
}

.index-nav1[data-v-8ee1fb6e]::-webkit-scrollbar {
    height: 3px
}

.index-nav1[data-v-8ee1fb6e]::-webkit-scrollbar-track {
    background: #0000000d
}

.index-nav1[data-v-8ee1fb6e]::-webkit-scrollbar-thumb {
    background: #667eea4d;
    border-radius: 1.5px
}

@media screen and (min-width: 1200px) {
    .index-nav1.original-brand-nav{
        transition:opacity .3s ease,transform .3s ease
    }

    .index-nav1.original-brand-nav.fade-out{
        opacity: .3;
        transform: scale(.95)
    }
}

.index-nav1 .brand-button{
    flex: 0 0 auto;
    min-width: fit-content;
    margin: 0 5px;
    padding: 10px 18px;
    font-size: 11px;
    white-space: nowrap;
    background: var(--card-bg);
    backdrop-filter: blur(40px) saturate(180%);
    border: 1px solid var(--border-color);
    border-radius: 24px;
    color: var(--text-primary);
    font-weight: 500;
    box-shadow: var(--shadow-sm);
    transition: all .4s cubic-bezier(.25,.46,.45,.94);
    position: relative;
    overflow: hidden;
    animation: buttonGlow-8ee1fb6e 2s ease-in-out infinite;
    cursor: pointer
}

.index-nav1 .brand-button[data-v-8ee1fb6e]:hover {
    transform: translateY(-1px);
    background: var(--bg-hover)
}

.index-nav1 .brand-button[data-v-8ee1fb6e]:active {
    transform: translateY(-2px) scale(1.02)
}

.index-nav1 .nav-item{
    width: 32%;
    margin-top: 10px;
    padding: 20px 16px;
    border-radius: 24px;
    background: var(--card-bg);
    box-shadow: var(--shadow-card);
    backdrop-filter: blur(10px);
    transition: all .4s cubic-bezier(.25,.46,.45,.94);
    position: relative;
    overflow: hidden;
    cursor: pointer
}

.index-nav1 .nav-item[data-v-8ee1fb6e]:hover {
    transform: translateY(-8px) scale(1.05);
    box-shadow: 0 16px 40px #667eea40
}

.index-nav1 .nav-item[data-v-8ee1fb6e]:active {
    transform: translateY(-4px) scale(1.02)
}

.index-nav1 .nav-item .nav-icon-wrapper{
    position: relative;
    display: flex;
    justify-content: center;
    margin-bottom: 10px
}

.index-nav1 .nav-item .nav-icon-wrapper .nav-icon{
    width: 48px!important;
    height: 48px;
    transition: all .3s ease;
    filter: drop-shadow(0 4px 12px rgba(0,0,0,.15))
}

.index-nav1 .nav-item .nav-icon-wrapper .nav-ripple{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80px;
    height: 80px;
    background: radial-gradient(circle,rgba(102,126,234,.2) 0%,transparent 70%);
    border-radius: 50%;
    transform: translate(-50%,-50%) scale(0);
    transition: transform .3s ease
}

.index-nav1 .nav-item .nav-text{
    font-size: 11px;
    color: var(--text-primary);
    font-weight: 500;
    text-align: center;
    transition: all .3s ease
}

.index-nav1 .nav-item:hover .nav-icon{
    transform: scale(1.1) rotate(5deg)
}

.index-nav1 .nav-item:hover .nav-ripple{
    transform: translate(-50%,-50%) scale(1.5)
}

.index-nav1 .nav-item:hover .nav-text{
    color: #667eea;
    font-weight: 600
}

.index-video{
    width: 100%;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 8px 30px #00000026
}

.vip-list{
    overflow-x: scroll;
    padding: 12px 10px;
    margin: 10px 0
}

.vip-list .vip-card{
    margin: 0 10px;
    padding: 16px;
    background: var(--card-bg);
    border-radius: 16px;
    box-shadow: var(--shadow-card);
    backdrop-filter: blur(10px);
    transition: all .3s cubic-bezier(.25,.46,.45,.94);
    min-width: 200px;
    max-width: 240px;
    position: relative;
    overflow: hidden
}

@media screen and (min-width: 1200px) {
    .vip-list .vip-card[data-v-8ee1fb6e]:hover {
        transform:translateY(-8px) scale(1.02);
        box-shadow: 0 16px 48px #667eea33
    }
}

.vip-list .vip-card .vip-icon-wrapper{
    position: relative;
    margin-right: 12px
}

.vip-list .vip-card .vip-icon-wrapper .vip-rank-badge{
    position: absolute;
    top: -2px;
    right: -2px;
    width: 16px;
    height: 16px;
    background: linear-gradient(135deg,#667eea,#764ba2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 9px;
    font-weight: 700;
    z-index: 2;
    box-shadow: 0 1px 3px #667eea4d
}

.vip-list .vip-card .vip-icon-wrapper .vip-icon{
    width: 48px!important;
    height: 48px;
    border-radius: 10px;
    transition: all .3s ease;
    filter: drop-shadow(0 2px 4px rgba(0,0,0,.1));
    border: 1px solid var(--border-color)
}

.vip-list .vip-card .vip-icon-wrapper .vip-glow{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 55px;
    height: 55px;
    background: radial-gradient(circle,rgba(102,126,234,.15) 0%,transparent 70%);
    border-radius: 50%;
    transform: translate(-50%,-50%);
    animation: glowPulse-8ee1fb6e 2s ease-in-out infinite;
    opacity: .5
}

.vip-list .vip-card .vip-icon-wrapper .vip-scan-line{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: linear-gradient(90deg,transparent,rgba(102,126,234,.4),transparent);
    animation: scanLine 3s linear infinite;
    opacity: .6
}

.vip-list .vip-card .vip-info{
    flex: 1
}

.vip-list .vip-card .vip-info .vip-name{
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 4px
}

.vip-list .vip-card .vip-info .vip-detail{
    font-size: 10px;
    color: var(--text-secondary);
    margin-bottom: 2px;
    line-height: 1.3
}

.new-list{
    height: 180px;
    background: linear-gradient(135deg,#667eea26,#764ba226);
    border: 2px solid rgba(102,126,234,.5);
    border-radius: 15px;
    padding: 15px;
    box-shadow: 0 4px 20px #667eea33;
    position: relative;
    overflow: hidden
}

.new-list[data-v-8ee1fb6e]:before {
    content: "";
    position: absolute;
    top: -2px;
    left: -100%;
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg,transparent,rgba(102,126,234,.8),transparent);
    animation: scanLineHorizontal-8ee1fb6e 4s linear infinite
}

.new-list .commission-scroll-container{
    height: 150px;
    overflow: hidden;
    position: relative
}

.new-list .commission-scroll-list{
    transition: transform .5s ease-in-out
}

.new-list .commission-item{
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px
}

.new-list .commission-item[data-v-8ee1fb6e]:last-child {
    margin-bottom: 0
}

.new-list .commission-item .commission-content{
    display: flex;
    align-items: center;
    background: var(--card-bg);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 10px 20px;
    width: 100%;
    max-width: 600px;
    height: 50px
}

.new-list .commission-item .commission-content .user-avatar{
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-right: 15px;
    border: 2px solid var(--border-color);
    background: var(--bg-secondary);
    object-fit: cover
}

.new-list .commission-item .commission-content .user-tel{
    flex: 1;
    font-size: 15px;
    color: var(--text-primary);
    font-weight: 500
}

.new-list .commission-item .commission-content .commission-amount{
    margin-left: auto;
    font-size: 16px;
    font-weight: 600;
    color: #667eea;
    white-space: nowrap
}

.goods-wrap{
    margin: 20px 0;
    padding: 0 10px
}

.goods-wrap .goods-container{
    display: grid;
    grid-template-columns: repeat(2,1fr);
    gap: 15px
}

@media screen and (min-width: 768px) {
    .goods-wrap .goods-container{
        grid-template-columns:repeat(3,1fr);
        gap: 20px
    }
}

@media screen and (min-width: 1200px) {
    .goods-wrap .goods-container{
        grid-template-columns:repeat(3,1fr);
        gap: 25px;
        max-width: 1000px;
        margin: 0 auto
    }
}

.goods-wrap .goods-item{
    background: var(--card-bg);
    border: 1px solid var(--border-color);
    border-radius: 12px;
    cursor: pointer;
    transition: all .3s cubic-bezier(.25,.46,.45,.94);
    overflow: hidden;
    box-shadow: var(--shadow-sm)
}

.goods-wrap .goods-item[data-v-8ee1fb6e]:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px #667eea26;
    border-color: #667eea
}

.goods-wrap .goods-item .img-row{
    height: 180px;
    overflow: hidden;
    background: var(--bg-secondary)
}

@media screen and (min-width: 768px) {
    .goods-wrap .goods-item .img-row{
        height:220px
    }
}

.goods-wrap .goods-item .img-row img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform .3s ease
}

.goods-wrap .goods-item .img-row:hover img{
    transform: scale(1.05)
}

.goods-wrap .goods-item .goods-name{
    padding: 10px 12px 5px;
    font-size: 14px;
    color: var(--text-primary);
    min-height: 40px;
    line-height: 1.4;
    font-weight: 500
}

.goods-wrap .goods-item .goods-price{
    padding: 0 12px 12px;
    font-size: 18px;
    color: #667eea;
    font-weight: 600
}

.index-title{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 18px;
    text-transform: uppercase;
    letter-spacing: 2px
}

.index-title .w1{
    width: 30px
}

.img-row{
    margin: 20px 0
}

.img-row img{
    width: 100%;
    height: auto;
    border-radius: 10px
}

.container{
    font-family: Linotype Didot,serif;
    font-size: 28px;
    font-weight: 300;
    text-align: center;
    margin: 40px 0 20px;
    color: var(--text-primary)
}

.container2{
    padding: 60px 20px;
    background-color: var(--bg-secondary);
    margin-top: 40px
}

.container2 .info{
    padding: 0 3em;
    margin: 20px auto;
    max-width: 800px;
    font-size: 14px;
    line-height: 1.8;
    color: var(--text-secondary)
}

.cta-button{
    background: linear-gradient(135deg,#667eea,#764ba2)!important;
    color: #fff!important;
    border-radius: 25px;
    padding: 20px 40px;
    font-weight: 600;
    box-shadow: 0 8px 25px #667eea4d;
    transition: all .3s ease;
    position: relative;
    overflow: hidden;
    display: inline-block;
    cursor: pointer
}

.cta-button[data-v-8ee1fb6e]:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: #fff3;
    border-radius: 50%;
    transition: all .4s ease;
    transform: translate(-50%,-50%)
}

.cta-button[data-v-8ee1fb6e]:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 35px #667eea66
}

.cta-button[data-v-8ee1fb6e]:hover:before {
    width: 300px;
    height: 300px
}

.cta-button[data-v-8ee1fb6e]:active {
    transform: translateY(-2px) scale(.98)
}

.index-foot{
    padding: 40px 20px;
    background: var(--bg-secondary);
    margin-top: 60px
}

.index-foot .h1{
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 15px;
    color: var(--text-primary)
}

.index-foot .shop{
    text-decoration: underline;
    color: #667eea;
    font-weight: 500;
    cursor: pointer;
    margin-top: 10px
}

.index-foot>div{
    margin: 10px 0;
    font-size: 14px;
    color: var(--text-secondary)
}

@keyframes glowPulse-8ee1fb6e {
    0%,to {
        opacity: .3;
        transform: translate(-50%,-50%) scale(.8);
        filter: blur(2px)
    }

    50% {
        opacity: .8;
        transform: translate(-50%,-50%) scale(1.2);
        filter: blur(0)
    }
}

@keyframes buttonGlow-8ee1fb6e {
    0%,to {
        box-shadow: 0 2px 8px #0000001a
    }

    50% {
        box-shadow: 0 4px 16px #667eea4d
    }
}

@keyframes scanLineHorizontal-8ee1fb6e {
    0% {
        left: -100%
    }

    to {
        left: 100%
    }
}

@keyframes borderGradient-8ee1fb6e {
    0% {
        background-position: 0% 50%
    }

    50% {
        background-position: 100% 50%
    }

    to {
        background-position: 0% 50%
    }
}

@keyframes dataStream-8ee1fb6e {
    0% {
        transform: translateY(100%);
        opacity: 0
    }

    20% {
        opacity: 1
    }

    80% {
        opacity: 1
    }

    to {
        transform: translateY(-100%);
        opacity: 0
    }
}

@keyframes neonGlow-8ee1fb6e {
    0%,to {
        text-shadow: 0 0 5px rgba(102,126,234,.5),0 0 10px rgba(102,126,234,.5),0 0 15px rgba(102,126,234,.5)
    }

    50% {
        text-shadow: 0 0 10px rgba(102,126,234,.8),0 0 20px rgba(102,126,234,.8),0 0 30px rgba(102,126,234,.8)
    }
}

@media screen and (min-width: 1200px) {
    .index-container{
        max-width:1400px;
        margin: 0 auto;
        padding: 0 40px
    }

    .header-brand-nav{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        background: transparent;
        backdrop-filter: none;
        box-shadow: none;
        border-bottom: none;
        overflow: hidden;
        margin: 0;
        padding: 0;
        height: 100%;
        max-height: 50px
    }

    .header-brand-nav .brand-button{
        font-size: 10px;
        padding: 5px 14px;
        background: var(--card-bg);
        border: 1px solid var(--border-color);
        border-radius: 8px;
        color: var(--text-primary);
        font-weight: 500;
        transition: all .2s ease;
        white-space: nowrap;
        min-width: fit-content;
        text-align: center;
        flex: 0 0 auto;
        height: 26px;
        line-height: 26px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin: 0 3px
    }

    .header-brand-nav .brand-button[data-v-8ee1fb6e]:hover {
        background: #667eeae6;
        color: #fff;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px #667eea4d
    }

    .vip-carousel-container{
        position: relative;
        width: 100%;
        height: 120px
    }

    .vip-carousel-container .vip-carousel-wrapper{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        position: relative
    }

    .vip-carousel-container .vip-carousel-wrapper .vip-card{
        position: absolute;
        transition: all .5s cubic-bezier(.25,.46,.45,.94)
    }

    .vip-carousel-container .vip-carousel-wrapper .vip-card.vip-card-center{
        transform: translate(0) scale(1);
        z-index: 3;
        opacity: 1
    }

    .vip-carousel-container .vip-carousel-wrapper .vip-card.vip-card-left{
        transform: translate(-350px) scale(.8);
        z-index: 2;
        opacity: .7
    }

    .vip-carousel-container .vip-carousel-wrapper .vip-card.vip-card-right{
        transform: translate(350px) scale(.8);
        z-index: 2;
        opacity: .7
    }

    .vip-carousel-container .vip-carousel-wrapper .vip-card.vip-card-hidden{
        transform: translate(0) scale(.6);
        z-index: 1;
        opacity: 0
    }

    .index-nav1:not(.original-brand-nav) .nav-item{
        flex: 0 0 auto;
        width: 160px;
        padding: 25px 15px
    }

    .index-nav1:not(.original-brand-nav) .nav-item .nav-icon-wrapper .nav-icon{
        width: 56px!important;
        height: 56px
    }

    .index-nav1:not(.original-brand-nav) .nav-item .nav-text{
        font-size: 15px;
        margin-top: 10px
    }

    .index-video{
        height: 450px;
        object-fit: cover;
        border-radius: 15px
    }
}

.m-flex{
    display: flex
}

.m-row-center{
    justify-content: center
}

.m-row-between{
    justify-content: space-between
}

.m-margin-1{
    margin: 15px
}

.m-margin-1-y{
    margin: 15px 0
}

.m-padding-1{
    padding: 10px
}

.m-padding-2{
    padding: 20px
}

.text-center{
    text-align: center
}

.p1{
    padding: 10px
}

.p6{
    padding: 30px
}

.w1{
    width: 30px
}

.w2{
    width: 48px
}

.btn{
    cursor: pointer;
    transition: all .3s ease
}

.inline{
    display: inline-block
}

.caps{
    text-transform: uppercase
}

.h3{
    font-size: 18px;
    font-weight: 500
}

[data-v-8ee1fb6e]::-webkit-scrollbar {
    display: none
}

@media screen and (max-width: 768px) {
    .vip-list{
        padding:8px 5px!important;
        margin: 5px 0!important
    }

    .vip-list .vip-card{
        min-width: 150px!important;
        max-width: 170px!important;
        padding: 10px!important;
        margin: 0 4px!important;
        border-radius: 12px!important
    }

    .vip-list .vip-card .vip-icon-wrapper{
        margin-right: 8px!important
    }

    .vip-list .vip-card .vip-icon-wrapper .vip-icon{
        width: 35px!important;
        height: 35px!important;
        border-radius: 8px!important
    }

    .vip-list .vip-card .vip-icon-wrapper .vip-rank-badge{
        width: 12px!important;
        height: 12px!important;
        font-size: 7px!important;
        top: 0!important;
        right: 0!important
    }

    .vip-list .vip-card .vip-icon-wrapper .vip-glow{
        width: 38px!important;
        height: 38px!important
    }

    .vip-list .vip-card .vip-icon-wrapper .vip-scan-line{
        display: none
    }

    .vip-list .vip-card .vip-info .vip-name{
        font-size: 11px!important;
        margin-bottom: 2px!important;
        font-weight: 500!important
    }

    .vip-list .vip-card .vip-info .vip-detail{
        font-size: 9px!important;
        margin-bottom: 1px!important;
        color: #888!important
    }

    .index-video{
        height: 200px!important
    }

    .container{
        font-size: 20px!important
    }

    .index-nav1{
        padding: 10px 5px!important
    }

    .index-nav1.original-brand-nav{
        justify-content: flex-start!important
    }

    .index-nav1.original-brand-nav .brand-button{
        padding: 8px 12px!important;
        font-size: 10px!important;
        margin: 0 3px!important;
        border-radius: 18px!important
    }
}

</style>
